module.exports = __webpack_public_path__ + "static/media/ad_bottom.0d4ca67a.png";